<template>
    <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
        <v-text-field
            v-model="cuitProfesional"
            :rules="obligatorioNumerico"
            label="Cuit del profesional"
            required
            variant="solo"
        ></v-text-field>
        <FacturadoresTotSelect
            @facturador-seleccionado="facturadorId = $event"
        ></FacturadoresTotSelect>
        <v-btn
            type="submit"
            :disabled="!valid"
            id="boton-verde"
            :loading="cargando"
        >
            {{ this.desasociar ? 'Desasociar' : 'Asociar'}}
        </v-btn>
    </v-form>
    <ClosableAlert
        v-if="alert"
        :type="alertType"
        :key="alertKey"
        :texto="mensaje"
        :titulo="desasociar ? 'Desasociar profesional facturador' : 'Asociar profesional facturador'"
    ></ClosableAlert>
</template>

<style src="../assets/general.css"></style>

<script>
    /* eslint-disable */
    import { obligatorioNumerico } from '@/_helpers/rules';
    import ClosableAlert from './ClosableAlert.vue';
    import ProfesionalService from '@/api/ProfesionalService';
    import FacturadoresTotSelect from './FacturadoresTotSelect.vue';
    import { OpcionesBusquedaProfesional } from '@/interfaces/adminInterfaces';

    const profesionalService = new ProfesionalService();

    export default{
        components: {
            ClosableAlert,
            FacturadoresTotSelect
        },
        props: {
            desasociar: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                valid: false,
                cuitProfesional: '',
                facturadorId: null,
                alert: false,
                obligatorioNumerico : obligatorioNumerico,
                cargando: false,
                //datos para mostrar errores
                alertType: '',
                alertKey: 0,
                mensaje: ''
            }
        },
        methods:{
            async handleSubmit(){
                this.cargando = true;
                const responseProfesional = await profesionalService.getProfesional(this.cuitProfesional);
                if(responseProfesional && responseProfesional.status == 200){
                    const profesionalId = responseProfesional.data.id;
                    let response;
                    if(this.desasociar){
                        response = await profesionalService.desasociarProfesionalFacturador(profesionalId, this.facturadorId);
                    } else {
                        response = await profesionalService.asociarProfesionalFacturador(profesionalId, this.facturadorId);
                    }
                    if(response && response.status == 200){
                        this.alertType = 'success';
                        this.mensaje = this.desasociar ? 'Profesional desasociado correctamente' : 'Profesional asociado correctamente';
                    }else{
                        this.alertType = 'error';
                        this.mensaje = this.desasociar ? 'Error al desasociar profesional' : 'Error al asociar profesional';
                    }
                } else {
                    this.alertType = 'error';
                    this.mensaje = 'Error al buscar profesional';
                }
                this.alert = true;
                this.alertKey += 1;
                this.cargando = false;
            },
        }
    }
</script>